<template>

  <modalo
    :title="templateapply.name"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => templateapply">

    <form
      id="templateapply-form"
      v-on:submit.prevent="saveTemplateapply(templateapply)">
      <div
        class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="templateapply.name">
        <ValidateMessage :error="validateErrors['name']" />
      </div>

      <div class="mb-3">
        <h5>{{ $t('Application question') }}</h5>
      </div>

      <TemplateapplyFormQuestions
        v-model="templateapply.application_questions"
        :validateErrors="validateErrors" />

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="templateapply-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="templateapply._id"
          type="button"
          class="btn btn-danger"
          @click="deleteTemplateapply(templateapply._id)">{{ $t('Delete') }}</button>  
      </div>
    </template>

  </modalo>

</template>

<script>
import TemplateapplyFormQuestions from './TemplateapplyFormQuestions'

export default {
  name: 'TemplateapplyForm',
  components: {
    TemplateapplyFormQuestions
  },
  props: [
    'initTemplateapply'
  ],
  data () {
    return {
      loading: false,
      templateapply: this.defaultValues(this.initTemplateapply),
      validateErrors: {}
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        'application_questions': [{
          'label': '',
          'required': true,
          'type': 'text', // [radio, textarea, checkbox, text]
          'options': []
        }]
      }, values)
    },
    addQuestion () {
      this.templateapply.application_questions.push({
        'label': '',
        'required': false,
        'type': 'text', // [radio, textarea, checkbox, text]
        'options': []
      })
    },
    removeQuestion (index) {
      this.templateapply.application_questions.splice(index, 1)
    },
    addOption (question) {
      question.push(null)
    },
    removeOption (question, index) {
      question.options.splice(index, 1)
    },
    /* hideModal  */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveTemplateapply
    */
    saveTemplateapply (data) {
      if (data._id) this.updateTemplateapply(data)
      else this.createTemplateapply(data)
    },
    /*
    createTemplateapply
    */
    createTemplateapply (data) {
      this.loading = true

      this.$store
      .dispatch('createTemplateapply', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateTemplateapply
    */
    updateTemplateapply (data) {
      this.loading = true

      this.$store
      .dispatch('updateTemplateapply', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteTemplateapply (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteTemplateapply', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Templateapply/TemplateapplyForm.vue